import Vuex from 'vuex'
import Vue from 'vue'
import user from './user'
import menu from './menu'
import booking from './booking'
import todo from './todo'
import audio from './audio'
import mail from './mail'
import socket from './socket'
import SocketPlugin from "@/plugins/socket-plugin";

Vue.use(Vuex)

const Store = new Vuex.Store({
  modules: {
    user,
    menu,
    booking,
    audio,
    mail,
    socket,
    todo
  }
})

SocketPlugin(Store); // <--- this line connects plugin in right, quasar-compatible way!

export default Store
